import { useCallback, useContext, useEffect } from 'react'
import { formats, messages, translations } from './calendar-utils'
import { ScheduleEditor } from '../create-schedule'
import { GlobalContext } from '../../../../../App'
import { metodoPrograma } from '../../../../../components/api'
import { AgendaContext } from '../..'
import { Calendar, dayjsLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import dayjs from 'dayjs'
import { EventRender } from './EventRender'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'

const localizer = dayjsLocalizer(dayjs)

const DragAndDropCalendar = withDragAndDrop(Calendar)

export const ConsultsList = ({ listaAgendamentos }) => {
  const { consults, dispatch, agendamentoSelecionado } =
    useContext(AgendaContext)
  const { agenda } = useContext(GlobalContext)

  const nrTempoAgenda = agenda?.[3] || 30

  const buscaDadosMedico = useCallback(
    (cdMedico) => {
      metodoPrograma('buscaDadosMedico', { cdMedico }).then((res) => {
        if (res.status) {
          dispatch({ field: 'medico', value: res })
        }
      })
    },
    [dispatch],
  )

  const onSelectEvent = (event) => {
    console.log('onSelectEvent', event)
    dispatch({
      field: 'agendamentoSelecionado',
      value: {
        data: event.data,
        modal: true,
        start: event.start,
        end: event.end,
      },
    })
  }

  const onSlotSelect = (slot) => {
    console.log('onSlotSelect', slot)
    dispatch({
      field: 'agendamentoSelecionado',
      value: {
        start: slot.start,
        end: slot.end,
        modal: true,
      },
    })
  }

  const onEventDrop = async ({ event, start, end, resourceId }) => {
    const obj = {
      idAgendamento: event.id,
      dtInicio: dayjs(start).format('YYYY-MM-DD HH:mm'),
      dtFim: dayjs(end).format('YYYY-MM-DD HH:mm'),
    }
    dispatch({
      type: 'setConsults',
      value: consults.map((value) => {
        const item = [...value]
        if (item[0] === event.id) {
          item[1] = start
          item[2] = end
          item[16] = resourceId
        }
        return item
      }),
    })
    await metodoPrograma('trocaPosicaoAgendamento', obj).then((res) => {
      if (res.status) {
        listaAgendamentos()
      }
    })
  }

  const onNavigate = (date) => {
    dispatch({ field: 'selectedDay', value: date })
  }

  useEffect(() => {
    if (agenda !== null) {
      buscaDadosMedico(agenda[2])
    }
    if (agendamentoSelecionado.modal === false) {
      dispatch({
        field: 'agendamentoSelecionado',
        value: { data: null, modal: false },
      })
    }
  }, [agenda, buscaDadosMedico, dispatch, agendamentoSelecionado.modal])

  return (
    <>
      <DragAndDropCalendar
        localizer={localizer}
        messages={messages}
        formats={formats}
        translations={translations}
        onSelectEvent={onSelectEvent}
        selectable
        onSelectSlot={onSlotSelect}
        onEventDrop={onEventDrop}
        components={{
          event: ({ event }) => <EventRender event={event} />,
        }}
        views={['day']}
        eventPropGetter={() => ({
          style: {
            backgroundColor: 'transparent',
            marginTop: 0,
            top: 0,
            paddingTop: 0,
            marginLeft: 5,
            marginRight: 5,
            cursor: 'pointer',
            border: 'none',
            color: 'transparent',
          },
        })}
        slotPropGetter={() => ({
          style: {
            backgroundColor: 'white',
            minHeight: '80px',
            cursor: 'pointer',
          },
        })}
        onNavigate={onNavigate}
        min={dayjs().hour(7).minute(0)}
        max={dayjs().hour(19).minute(0)}
        step={nrTempoAgenda}
        timeslots={1}
        startAccessor="start"
        endAccessor="end"
        defaultView="day"
        events={consults?.map((item) => ({
          id: item[0],
          title: item[3],
          start: new Date(item[1]),
          end: new Date(item[2]),
          data: item,
        }))}
        hourFormat="24"
        style={{ height: 'calc(100vh - 50px)', marginTop: '20px' }}
      />
      {agendamentoSelecionado.modal && (
        <ScheduleEditor listaAgendamentos={listaAgendamentos} />
      )}
    </>
  )
}
